<template>
  <div class="DateHistoryDetailViewContainer">
    <span style="font-size: 24px" class="whiteFont boldFont prd8 vmg4">{{ stateMap[drill.state] }}</span>
    <span class="whiteFont smallFont pd8">期望时间：{{ drill.expectStartTime }} ~ {{ drill.expectEndTime }}</span>
    <div class="wbg pd16 colFlex brd16 vmg16">
      <span class="baseFont boldFont mb8">预约信息</span>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">活动内容</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">演练</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">演练单位</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{drill.stationName}}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">演练地址</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.address }}</span>
        </nut-col>
      </nut-row>
    </div>
    <div class="wbg pd16 colFlex brd16 mb16">
      <span class="baseFont boldFont mb8">联系人信息</span>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">联系人</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ desensitize.desensitizeChineseName(drill.teamLeader) }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">联系号码</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ desensitize.desensitizePhone(drill.teamLeaderPhone) }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">申请单位</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.applyUnitName }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">所在区划</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.addressArea }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">单位地址</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.address }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter vmg4">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">演练人数</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.personNum }}</span>
        </nut-col>
      </nut-row>
    </div>
    <div class="wbg pd16 colFlex brd16">
      <nut-row class="bothCenter">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">申请时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.createdTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16" v-if="drill.auditTime">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">审核时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.auditTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16" v-if="drill.confirmStartTime">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">确定时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.confirmStartTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16" v-if="drill.actualStartTime">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">开始时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.actualStartTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16" v-if="drill.actualEndTime">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont" style="color:#999999;">完成时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.actualEndTime }}</span>
        </nut-col>
      </nut-row>
      <nut-row class="bothCenter mt16 lightRed" v-if="drill.state == 'CANCEL'">
        <nut-col :span="6" class="leftCenter">
          <span class="smallFont">驳回时间</span>
        </nut-col>
        <nut-col :span="18" class="leftCenter">
          <span class="smallFont boldFont">{{ drill.auditTime }}</span>
        </nut-col>
      </nut-row>
      <div class="reject smallFont lightRed pd8 brd8 mt16" v-if="drill.state == 'CANCEL'">
        <span>理由：{{ drill.reason }}</span>
      </div>
    </div>
    <div class="pd16 colFlex mt8 bothCenter" v-if="!['FINISH','CANCEL'].includes(drill.state)">
      <nut-button class="commentBtn" @click="cancelFn">我要取消</nut-button>
    </div>
    <div class="pd16 colFlex mt8 bothCenter" v-if="drill.needEvaluate">
      <nut-button class="commentBtn" @click="$router.push('/drill/evaluate/'+drill.id)">我要评价</nut-button>
    </div>
    <UserEvaluation :evaluations="drill.evaluations" v-if="drill?.evaluations"/>
  </div>
</template>

<script>
import api from "@/api";
import desensitize from "../../utils/desensitize";
import UserEvaluation from "@/views/evaluate/UserEvaluation.vue";
import {Dialog, Toast} from "@nutui/nutui";
export default {
  name: "drillDateHistoryDetailView",
  components: {UserEvaluation},
  computed: {
    desensitize() {
      return desensitize
    }
  },
  data() {
    return {
      dateId: this.$route.params.dateId,
      drill: {},
      drillState: '-',
      leader: {},
      stateMap: {
        INIT: "未提交",
        COMMIT: "待审核",
        CANCEL: "已取消",
        PASS: "待演练",
        PROCESSING: "演练中",
        FINISH: "已完成",
      }
    }
  },
  methods: {
    cancelFn(){
      Dialog({
        title:'取消',
        content:'确定取消演练吗?',
        onOk:()=>{
          api.cancelDrill({
            drillId:this.drill.id
          }).then(()=>{
            Toast.success('取消成功');
            this.init();
          })
        }
      })
    },
    init() {
      api.getMyDrillDateList({
        dateId: this.dateId,
      }).then(ret => {
        this.drill = ret[0];
      })
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.DateHistoryDetailViewContainer {
  display: flex;
  flex-direction: column;
  background-color: #F4F6F9;
  padding: 16px;
  background-image: url("https://cdn.waityou.online/37cb1d79-9515-335c-c596-fceff43c4a7c.png");
  background-size: 100%;
  background-position: top;
  background-repeat: no-repeat;
  min-height: calc(100vh - 32px);

  .commentBtn{
    width: 50%;
    border: none;
    color:white;
    height: 44px;
    background: #2F438C;
    border-radius: 12px;
  }

  .reject {
    background-color: rgba(255, 30, 50, 0.1);;
  }

  .lightRed {
    color: #FF1E32;
  }

  .joiner {
    width: 28px;
    height: 28px;
    border-radius: 14px;
  }

  .coverLeft {
    margin-left: -14px;
  }
}
</style>